import { getCategory } from "../data/articleCategories";

/**
 * Generated cover art for an article: a category-tinted gradient, a dot grid and
 * the category icon. Drawn entirely in CSS/SVG, so it costs no image requests
 * and stays consistent across the 34 articles.
 */
export const ArticleCover = ({ article, className = "", iconSize = 128, showLabel = true }) => {
  const category = getCategory(article);
  const Icon = category.icon;

  return (
    <div
      className={`relative overflow-hidden bg-[#0F0F10] ${className}`}
      style={{
        "--cat": category.color,
        "--cat-rgb": category.rgb,
        backgroundImage: `
          radial-gradient(120% 120% at 12% 0%, rgba(var(--cat-rgb), 0.32) 0%, transparent 62%),
          radial-gradient(100% 100% at 100% 100%, rgba(var(--cat-rgb), 0.16) 0%, transparent 58%)
        `,
      }}
    >
      {/* dot grid */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage: "radial-gradient(rgba(255,255,255,0.07) 1px, transparent 1px)",
          backgroundSize: "14px 14px",
        }}
      />

      {/* oversized category glyph */}
      <div aria-hidden="true" className="absolute -right-4 -bottom-6 opacity-[0.22]">
        <Icon
          size={iconSize}
          strokeWidth={1}
          style={{ color: "var(--cat)" }}
          className="transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6"
        />
      </div>

      {showLabel && (
        <div className="absolute top-4 left-4">
          <span
            className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium backdrop-blur-md border"
            style={{
              color: "var(--cat)",
              borderColor: "rgba(var(--cat-rgb), 0.35)",
              backgroundColor: "rgba(0,0,0,0.45)",
            }}
          >
            <Icon size={12} strokeWidth={2} />
            {category.label}
          </span>
        </div>
      )}

      {/* bottom fade so text below the cover reads cleanly */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-[#0F0F10] to-transparent"
      />
    </div>
  );
};
